import React from 'react'
import './style.css.scss'

const SkeletonTile = () => (
  <div className="skeleton-tile">
    <div className="animated-background">
        <div className="skeleton-details" />
        <div className="background-masker skeleton-title-row" />
        <div className="background-masker skeleton-below-title" />
        <div className="background-masker skeleton-below-description" />
    </div>
  </div>
)

export default SkeletonTile
